module.exports = __webpack_public_path__ + "media/images/technology/team-icon-929f7bab30f57b3a2550ddd8c74c33f7.png";